import {Box, Typography} from '@mui/material'
import React from 'react'

interface ValueContainerProps {
  label: string
  children: React.ReactNode
}

/**
 * Container for the quantity value with floating label.
 * Private component used internally by QuantityInput, can be extracted if needed.
 */
export const ValueContainer: React.FC<ValueContainerProps> = ({label, children}) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        minWidth: 0,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0
      }}
    >
      {/* Floating Label */}
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: '#52667a',
          textAlign: 'center',
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </Typography>

      {/* Value Display/Edit Area */}
      <Box
        sx={{
          height: '22px',
          width: '100%',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '4px'
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
